export const url = "https://guarded-ridge-50822.herokuapp.com/api/v1";
export const local_url = "http://localhost:8080/api/v1";

export const productsObjs = {
  loadingProducts: false,
  products: [
    {
      id: 1,
      name: "Face mask",
      description: "Checked",
      price: 19,
      createdDate: "2019-07-04T13:23:55+0000",
      image:
        "https://firebasestorage.googleapis.com/v0/b/decom-599ca.appspot.com/o/0681814c978e23e335eeef9a4fa202e5.jpeg?alt=media&token=7e0b96a1-eaf7-42b9-96c4-8b5e1b45cf7b"
    },
    {
      id: 11,
      name: "Face mask",
      description: "Eagle",
      price: 18,
      createdDate: "2019-07-04T13:23:55+0000",
      image:
        "https://firebasestorage.googleapis.com/v0/b/decom-599ca.appspot.com/o/11700f56bb178fe38607b417d60f2085.jpg?alt=media&token=cdb46657-76f8-4222-8c3c-2c2c16f5e491"
    },
    {
      id: 21,
      name: "Face mask",
      description: "Genuine Leather",
      price: 17,
      createdDate: "2019-07-04T13:23:55+0000",
      image:
        "https://firebasestorage.googleapis.com/v0/b/decom-599ca.appspot.com/o/953f9ef00fd02a60e82204dcb61e0544.jpeg?alt=media&token=a913cd5a-af7c-4884-847e-cb9259743c04"
    },
    {
      id: 31,
      name: "Face mask",
      description: "Leopard",
      price: 21,
      createdDate: "2019-07-04T13:23:55+0000",
      image:
        "https://firebasestorage.googleapis.com/v0/b/decom-599ca.appspot.com/o/Rochele-Masks-2.jpg?alt=media&token=34db91f5-d027-4a0e-9f16-12581aa06d75"
    },
    {
      id: 41,
      name: "Face mask",
      description: "Semi-milk bottle",
      price: 5,
      createdDate: "2019-07-04T13:23:55+0000",
      image:
        "https://firebasestorage.googleapis.com/v0/b/decom-599ca.appspot.com/o/alternative-coronavirus-masks-max-siedentopf_dezeen_2364_col_5.jpg?alt=media&token=995e82f2-8ec6-48e8-b67c-aa8261c969c5"
    },
    {
      id: 51,
      name: "Face mask",
      description: "Traditional blue",
      price: 13,
      createdDate: "2019-07-04T13:23:55+0000",
      image:
        "https://firebasestorage.googleapis.com/v0/b/decom-599ca.appspot.com/o/download.jpeg?alt=media&token=13f627ef-e1fa-4ee4-a372-3ffbc47186c8"
    },
    {
      id: 61,
      name: "Face mask",
      description: "South Africa",
      price: 23,
      createdDate: "2019-07-04T13:23:55+0000",
      image:
        "https://firebasestorage.googleapis.com/v0/b/decom-599ca.appspot.com/o/fa9000-GREENBLACK_1.jpg?alt=media&token=2839b732-bf7a-492a-985a-08823bc3e23e"
    },
    {
      id: 71,
      name: "Face mask",
      description: "Ikea",
      price: 11,
      createdDate: "2019-07-04T13:23:55+0000",
      image:
        "https://firebasestorage.googleapis.com/v0/b/decom-599ca.appspot.com/o/ikea-diy-face-mask.png?alt=media&token=bfe7a3d8-c17d-4a09-8f1b-288a08127a04"
    },
    {
      id: 81,
      name: "Face mask",
      description: "Norway",
      price: 24,
      createdDate: "2019-07-04T13:23:55+0000",
      image:
        "https://firebasestorage.googleapis.com/v0/b/decom-599ca.appspot.com/o/leirendesigns_NorwayflagMASK_Norwegian_formatted_large.jpg?alt=media&token=af75f8c6-4626-47bd-baef-b28be72d0b6d"
    },
    {
      id: 101,
      name: "Face mask",
      description: "Checked",
      price: 19,
      createdDate: "2019-07-04T13:23:55+0000",
      image:
        "https://firebasestorage.googleapis.com/v0/b/decom-599ca.appspot.com/o/0681814c978e23e335eeef9a4fa202e5.jpeg?alt=media&token=7e0b96a1-eaf7-42b9-96c4-8b5e1b45cf7b"
    },
    {
      id: 111,
      name: "Face mask",
      description: "Eagle",
      price: 18,
      createdDate: "2019-07-04T13:23:55+0000",
      image:
        "https://firebasestorage.googleapis.com/v0/b/decom-599ca.appspot.com/o/11700f56bb178fe38607b417d60f2085.jpg?alt=media&token=cdb46657-76f8-4222-8c3c-2c2c16f5e491"
    },
    {
      id: 121,
      name: "Face mask",
      description: "Genuine Leather",
      price: 17,
      createdDate: "2019-07-04T13:23:55+0000",
      image:
        "https://firebasestorage.googleapis.com/v0/b/decom-599ca.appspot.com/o/953f9ef00fd02a60e82204dcb61e0544.jpeg?alt=media&token=a913cd5a-af7c-4884-847e-cb9259743c04"
    },
    {
      id: 131,
      name: "Face mask",
      description: "Leopard",
      price: 21,
      createdDate: "2019-07-04T13:23:55+0000",
      image:
        "https://firebasestorage.googleapis.com/v0/b/decom-599ca.appspot.com/o/Rochele-Masks-2.jpg?alt=media&token=34db91f5-d027-4a0e-9f16-12581aa06d75"
    },
    {
      id: 141,
      name: "Face mask",
      description: "Semi-milk bottle",
      price: 5,
      createdDate: "2019-07-04T13:23:55+0000",
      image:
        "https://firebasestorage.googleapis.com/v0/b/decom-599ca.appspot.com/o/alternative-coronavirus-masks-max-siedentopf_dezeen_2364_col_5.jpg?alt=media&token=995e82f2-8ec6-48e8-b67c-aa8261c969c5"
    },
    {
      id: 151,
      name: "Face mask",
      description: "Traditional blue",
      price: 13,
      createdDate: "2019-07-04T13:23:55+0000",
      image:
        "https://firebasestorage.googleapis.com/v0/b/decom-599ca.appspot.com/o/download.jpeg?alt=media&token=13f627ef-e1fa-4ee4-a372-3ffbc47186c8"
    },
    {
      id: 161,
      name: "Face mask",
      description: "South Africa",
      price: 23,
      createdDate: "2019-07-04T13:23:55+0000",
      image:
        "https://firebasestorage.googleapis.com/v0/b/decom-599ca.appspot.com/o/fa9000-GREENBLACK_1.jpg?alt=media&token=2839b732-bf7a-492a-985a-08823bc3e23e"
    },
    {
      id: 171,
      name: "Face mask",
      description: "Ikea",
      price: 11,
      createdDate: "2019-07-04T13:23:55+0000",
      image:
        "https://firebasestorage.googleapis.com/v0/b/decom-599ca.appspot.com/o/ikea-diy-face-mask.png?alt=media&token=bfe7a3d8-c17d-4a09-8f1b-288a08127a04"
    },
    {
      id: 181,
      name: "Face mask",
      description: "Norway",
      price: 24,
      createdDate: "2019-07-04T13:23:55+0000",
      image:
        "https://firebasestorage.googleapis.com/v0/b/decom-599ca.appspot.com/o/leirendesigns_NorwayflagMASK_Norwegian_formatted_large.jpg?alt=media&token=af75f8c6-4626-47bd-baef-b28be72d0b6d"
    }
  ],
  loadedProducts: true,
  errorMessage: null
};

export const incorrectDetails = "Your email or password was incorrect";
